<template>
  <div>
    <div class="articlelist">
      <el-table :data="articleList">
        <el-table-column prop="date" label="文章列表">
          <template slot-scope="scope">
            <div class="title">
              <router-link
                :to="{ name: 'articleedit', query: { id: scope.row.id } }"
                class="left"
              >
                <h4>{{ scope.row.title }}<span class="auditstate">({{ scope.row.auditState==0?"未审核":"审核通过" }})</span></h4>
              </router-link>
              <i
                class="el-icon-close right close-btn"
                @click="deleteArticle(scope.row.id)"
              ></i>
            </div>
            <div style="clear: both"></div>
            <div class="desc-container">
              <div class="desc online left">{{ scope.row.desc }}</div>
              <div class="right views">
                <i class="el-icon-view right">&nbsp;{{ scope.row.views }}</i>
                <!-- <i class="el-icon-chat-line-square right">19999</i> -->
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <br/>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="totalNum"
      :page-size="15"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>
<style scoped>
h4 {
  padding: 0px;
  margin: 0px;
  padding-bottom: 6px;
}
.articlelist {
  text-align: left;
  width: 100%;
  margin: 0 auto;
}
.left {
  float: left;
}
.right {
  float: right;
}
.auditstate{color:#bdb9b9;font-size:12px;font-weight: normal;}
.title {
  position: relative;
}
.close-btn {
  padding-top: 4px;
  cursor: pointer;
}
.desc {
  font-size: 14px;
  color: #8a8a8a;
  width: 80%;
}
.online {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.views {
  line-height: 23px;
  padding-top: 6px;
}
.views > i {
  padding-left: 8px;
}
</style>
<script>
export default {
  data() {
    return {
      totalNum: 0,
      articleList: [],
      pageIndex: 1,    
    };
  },
  mounted() {
    this.getTotalNum();
    this.getList(1);
  },
  methods: {
    getTotalNum() {
      //获取文章总数量
      this.$http
        .get("/api/article")
        .then((r) => {
          this.totalNum = r.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getList(pageIndex) {
      this.pageIndex = pageIndex;
      this.$http
        .get("/api/article/" + pageIndex)
        .then((r) => {
          console.log(r);
          //获取角色列表
          if (r.data.code == 200) {
            this.articleList = r.data.data;
          } else {
            this.$alert("获取数据失败，请重试", "", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    handleCurrentChange(pageIndex) {
      this.getList(pageIndex);
    },
    deleteArticle(id) {
      if (id > 0) {
        this.$confirm("此操作将永久删除文章, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$http
            .delete("/api/article/" + id)
            .then((res) => {
              if (res.data == 1) {
                this.$message.info("删除成功");
                //重新获取列表数据
                this.getList(this.pageIndex);
              } else {
                this.$message.info("删除失败");
              }
            })
            .catch((err) => {
              console.log(err);
            });
        });
      }
    },
  },
};
</script>
